import axios from 'axios';

// initial state
const state = {
    isLoading: false,
    premioQtdTmp: 0,
    premios: [],
    resgates: [],
    saldoCampanhaPontos: 0
}

// getters
const getters = {
    //
}

// actions
const actions = {
    getSaldoCampanhaPontos({ commit, state }) {
        state.isLoading = true;
        return axios
            .get(API_URL + '/campanha-pontos/saldo-pontos-cliente-api')
            .then(response => {
                state.isLoading = false;
                commit('setSaldoCampanhaPontos', response.data.saldoCampanhaPontos);
                return response.data.saldoCampanhaPontos;
            });
    },
    getPremiosSelecionados({ commit, state }) {
        state.isLoading = true;
        return axios
            .get(API_URL + '/campanha-pontos/resgate-pontos-premios-selecionados-api')
            .then(response => {
                state.isLoading = false;
                commit('setPremiosSelecionados', response.data.premios);
                return response.data.premios;
            });
    },
    getMeusResgates({ commit, state }) {
        state.isLoading = true;
        return axios
            .get(API_URL + '/campanha-pontos/meus-resgates-api')
            .then(response => {
                state.isLoading = false;
                commit('setMeusResgates', response.data.resgates);
                return response.data.resgates;
            });
    },
    incrementaQtdPremio: function({ commit, state, dispatch }, premio) {
        state.premioQtdTmp = parseInt(premio.quantidade); 
        premio.quantidade = parseInt(premio.quantidade) + 1;
        return dispatch('atualizarPremio', premio);
    },
    decrementaQtdPremio: function({ commit, state, dispatch }, premio) {
        state.premioQtdTmp = parseInt(premio.quantidade);
        premio.quantidade = Math.max(0, parseInt(premio.quantidade) - 1);
        return dispatch('atualizarPremio', premio);
    },
    adicionarPremio: function({ commit, state, dispatch }, premio) {
        var vm = this;
        return new Promise((resolve, reject) => {
            if (premio.quantidade <= 0)
            {
                reject('Quantidade inválida');
            }
            else
            {
                axios.post(API_URL + '/campanha-pontos/resgate-pontos-adicionar-premio-lista', {
                    id: premio.premio_id,
                    qtd: premio.quantidade
                })
                .then(response => {
                    if (response.data.error)
                    {
                        reject(response.data.error);
                    }
                    else
                    {
                        dispatch('getPremiosSelecionados').then(result => resolve(result)).catch(error => reject(error));
                    }
                });
            }
        });
    },
    atualizarPremio: function({ commit, state, dispatch }, premio) {
        var vm = this;
        state.isLoading = true;
        return new Promise((resolve, reject) => {
            if (premio.quantidade <= 0)
            {
                state.isLoading = false;
                premio.quantidade = 1;                
                reject('Quantidade inválida');
            }
            else
            {
                axios.post(API_URL + '/campanha-pontos/resgate-pontos-atualizar-lista-premios', {
                    id: premio.premio_id,
                    qtd: premio.quantidade
                })
                .then(response => {
                    state.isLoading = false;
                    if (response.data.error)
                    {
                        premio.quantidade = state.premioQtdTmp;
                        state.premioQtdTmp = 0;
                        reject(response.data.error);
                    }
                    else
                    {
                        dispatch('getPremiosSelecionados').then(result => resolve(result)).catch(error => reject(error));
                    }
                });
            }
        });
    },
    removerPremio: function({ commit, state, dispatch }, premio) {
        var vm = this;
        state.isLoading = true;
        return new Promise((resolve, reject) => {
            axios.post(API_URL + '/campanha-pontos/resgate-pontos-remover-premio-lista', {
                id: premio.premio_id
            })
            .then(response => {
                state.isLoading = false;
                if (response.data.error)
                {
                    reject(response.data.error);
                }
                else
                {
                    dispatch('getPremiosSelecionados').then(result => resolve(result)).catch(error => reject(error));
                }
            });
        });
    },
    dispatchSolicitacaoResgate({ commit, state }) {
        return 'solicitacao-resgate-enviada';
    },
    dispatchConfirmacaoRecebimentoPremio({ commit, state }) {
        return 'confirmacao-recebimento-premio-enviada';
    },
    enviarSolicitacaoResgate: function({ commit, state, dispatch }, premiosResgatar) {
        var vm = this;
        //state.isLoading = true;
        return new Promise((resolve, reject) => {
            axios.post(API_URL + '/campanha-pontos/resgate-pontos-enviar-solicitacao', {
                premiosResgate: premiosResgatar
            })
            .then(response => {
                //state.isLoading = false;
                if (response.data.error)
                {
                    reject(response.data.error);
                }
                else if (response.data.success)
                {
                    dispatch('dispatchSolicitacaoResgate').then(result => resolve(result)).catch(error => reject(error));
                }
            });
        });
    },
    confirmarRecebimentoPremio: function({ commit, state, dispatch }, premioResgateConfirmar) {
        var vm = this;
        //state.isLoading = true;
        return new Promise((resolve, reject) => {
            axios.post(API_URL + '/campanha-pontos/meus-resgates-confirmar-recebimento', {
                id: premioResgateConfirmar.id,
                resgate_id: premioResgateConfirmar.resgate.resgate_id
            })
            .then(response => {
                //state.isLoading = false;
                if (response.data.error)
                {
                    reject(response.data.error);
                }
                else if (response.data.success)
                {
                    dispatch('dispatchConfirmacaoRecebimentoPremio').then(result => resolve(result)).catch(error => reject(error));
                }
            });
        });
    }
}

// mutations
const mutations = {
    setPremiosSelecionados (state, premios) { state.premios = premios; },
    setMeusResgates (state, resgates) { state.resgates = resgates; },
    setSaldoCampanhaPontos (state, saldoCampanhaPontos) { state.saldoCampanhaPontos = saldoCampanhaPontos; }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}